//import axios to make request
import axios from "axios";

// add distributor
export async function addDistributor({ commit }, payload) {
  try {
    const { data } = await axios.post("/distributors/add", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

// update distributor
export async function updateDistributor({ commit }, payload) {
  try {
    const { data } = await axios.put("/distributors/update", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

// get farms
export async function getFarms({ commit }, payload) {
  try {
    const { data } = await axios.get("/distributors/farms", {
      params: payload,
    });

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getDistributorsByName({ commit }, payload) {
  try {
    const { data } = await axios.get(
      "distributors/get-distributors-by-packages",
      {
        params: payload,
      }
    );

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}
